// const API_BASE_URL = process.env.REACT_APP_BASE_URL + "rest/V1/"; //'https://b2cdevserver.redingtonmea.com/rest/V1/';
// const API_BASE_URL_DEFAULT =
//   process.env.REACT_APP_BASE_URL + "rest/default/V1/";
// console.log("REACT_APP_DEFAULT_PRODUCT_IMAGE:>>" , process.env.REACT_APP_DEFAULT_PRODUCT_IMAGE ) ;  

const ensureTrailingSlash = (value = "") => {
  if (!value) {
    return ""
  }
  return value.endsWith("/") ? value : `${value}/`
}

const stripLeadingSlashes = (value = "") =>
  typeof value === "string" ? value.replace(/^\/+/, "") : ""

const isAbsoluteUrl = (value = "") => /^https?:\/\//i.test(value)

const appendPath = (base, path = "") => {
  if (!path) {
    return base
  }

  if (isAbsoluteUrl(path)) {
    return path
  }

  if (!base) {
    return path
  }

  return `${base}${stripLeadingSlashes(path)}`
}

const rawApiBase =
  process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BASE_URL || "";


const localRawApiBase = process.env.REACT_APP_LOCAL_BASE_URL;
const rawAssetBase =
  process.env.REACT_APP_ASSET_BASE_URL ||
  process.env.REACT_APP_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  ""

const API_HOST = rawApiBase ? ensureTrailingSlash(rawApiBase) : "";
const LOCAL_HOST = localRawApiBase ? ensureTrailingSlash(localRawApiBase) : "";

const ASSET_HOST = rawAssetBase ? ensureTrailingSlash(rawAssetBase) : ""

// Legacy Magento-style order paths (coupons, reorder, etc.)
const API_BASE_URL = `${LOCAL_HOST}store/mp/orders/`; 

const API_BASE_URL_DEFAULT = `${API_HOST}rest/default/V1/`;
const SIZE_LIST_URL = "products/attributes/142/options";
const COLOR_LIST_URL = "products/attributes/93/options";
//const SIZE_LIST_URL = 'products/attributes/145/options';
// const PRODUCT_SEARCH =
//   "products?searchCriteria[filter_groups][0][filters][1][field]=status&searchCriteria[filter_groups][0][filters][1][value]=1&searchCriteria[filter_groups][0][filters][0][field]=category_id&searchCriteria[filter_groups][0][filters][0][value]="; 
export const PRODUCT_SEARCH = "&searchCriteria[filter_groups][0][filters][1][field]=status&searchCriteria[filter_groups][0][filters][1][value]=1";
const CATEGORY_SEARCH = "store/mp/products/searchbycategory?searchCriteria[filter_groups][0][filters][0][field]=category_id&searchCriteria[filter_groups][0][filters][0][value]="
// const ALL_PRODUCT_SEARCH =
//   "products?searchCriteria[filter_groups][0][filters][1][field]=status&searchCriteria[filter_groups][0][filters][1][value]=1";
const ALL_PRODUCT_SEARCH = "store/mp/products?searchCriteria[filter_groups][0][filters][0][field]=status&searchCriteria[filter_groups][0][filters][0][value]=1&searchCriteria[filter_groups][0][filters][0][condition_type]=eq"
// const CHECK_ORDER_RETURN = "checkOrderReturn";  
// const CHECK_ORDER_RETURN="store/mp/check-order-return";
const CHECK_ORDER_RETURN = "store/order-return";
// const PRODUCT_BY_ID = "products/"; 
const PRODUCT_BY_ID = "store/mp/products/";
const CONFIRM_RETURN = "requestOrderReturn";
const CATEGORY_LIST = "categories";
// const GUEST_CART = "guest-carts/";  
const GUEST_CART = 'store/mp/guest-user/guest-carts/';
const GUEST_CART_CHECKOUT_BASE = `${LOCAL_HOST}${GUEST_CART}`;
const MERGE_CART = 'store/mp/guest-user/guest-cart-merge';
// const PRODUCT_ENQUIRY = "redington-outofstockproductenquiry/productenquiry"; 
const PRODUCT_ENQUIRY = "store/mp/redington-outofstockproductenquiry/productenquiry";
// const COUNTRY_LIST = "directory/countries";
const COUNTRY_LIST = "store/mp/countries";
// const CUSTOMERS = "customers";
const CUSTOMERS = "auth/customer/emailpass/register";
const UPDATE_ADDRESS = "store/mp/customers/me";
const REGISTER_CUSTOMER = "store/mp/auth/register"
// const LOGIN_USER = "integration/customer/token";
const LOGIN_USER = "auth/customer/emailpass";
const USER_EXIST = "store/mp/guest-user/email-check";
// const CARTS_MINE = "carts/mine";
const CARTS_MINE = "store/mp/carts/mine";
const ORDER_HISTORY = "store/mp/orders";
const CMS_PAGE = "store/mp/customers/cms-page";
const ITEMS = "/items";
// const CUSTOMER = "customers/me";
const CUSTOMER = "store/mp/auth/me";
const SHIPPINGMETHOD = "/shipping-methods";
const PREVIOUSORDERS =
  "orders?searchCriteria[filter_groups][0][filters][0][field]=customer_email&searchCriteria[filter_groups][0][filters][0][value]=";
const PRODUCTSQUERY = "store/mp/products/search?";
// const BANNERSLIDERS = "admin/redington/banner-sliders";  
const BANNERSLIDERS = "store/mp/banner_sliders";
const RECOMMENDEDPRODUCTS =
  "products?searchCriteria[filter_groups][0][filters][0][field]=on_home&searchCriteria[filter_groups][0][filters][0][value]=1&searchCriteria[filter_groups][0][filters][0][condition_type]=gteq&searchCriteria[filter_groups][1][filters][0][field]=status&searchCriteria[filter_groups][1][filters][0][value]=1";
const SEARCH_PARAMS =
  "?searchCriteria[sortOrders][0][field]=identifier&searchCriteria[sortOrders][0][direction]=asc&searchCriteria[filterGroups][0][filters][0][field]=identifier&searchCriteria[filterGroups][0][filters][0][value]=";
const COOKIEPOLICY_PARAMS =
  "?searchCriteria[filter_groups][0][filters][0][field]=status&searchCriteria[filter_groups][0][filters][0][value]=yes";
const VIDEOURL_PARAMS =
  "?searchCriteria[filter_groups][0][filters][0][field]=status&searchCriteria[filter_groups][0][filters][0][value]=yes";

// const SENDOTP = "otp/send";
const SENDOTP = "store/mp/customer/otp/send";
// const VERIFYOTP = "otp/verify";
const VERIFYOTP = "store/mp/customer/otp/verify";
const RESET_PASSWORD = 'auth/customer/emailpass/reset-password';
const GUESTUSERVERIFY = "guestuser/guestuserverify";
// const GUESTUSERALLOWEDDOMAIN = "redington/allowed_domains";  
const GUESTUSERALLOWEDDOMAIN = "store/mp/allowed-domains"
// const GUESTUSERURLDECRYPT ="url/decrypt";  
const GUESTUSERURLDECRYPT = "store/mp/url-crypto/decrypt";
const GUESTUSER_VERIFY_ENCRYPTED_URL =
  "store/mp/guest-user/verify-encrypted-url";
// const GUESTUSERTOKEN = "guestuser/token";

// const UPDATEPASSWORD = "password/update"; 
const UPDATEPASSWORD = "auth/customer/emailpass/update";
// /rest/<store_code>/V1/products?searchCriteria[filter_groups][0][filters][0][field]=sku&searchCriteria[filter_groups][0][filters][0][value]=&searchCriteria[filter_groups][0][filters][0][condition_type]=like

// const RETURN_MANAGEMENT = "returnView?customer_email=";
const RETURN_MANAGEMENT = "store/mp/orders/return-view";

// const GENERATE_INVOICE = "b2cgetinvoice";
const GENERATE_INVOICE = "getInvoice";

// const GETDOMAINDETAILS = "access-mapping/getDomainDetails";
const GETDOMAINDETAILS = "store/mp/domain/get-domain-details";

// const getCategory = "category-restriction/getCategories/";
const getCategory = "store/mp/category-restriction/getCategories/";
// const maxOrderQty = "max-order-qty/getMaxOrderQty/";  
const maxOrderQty = "store/mp/max-order-qty/getMaxOrderQty";
// const userInfo = "customer-info/getCustomerInfo";
const userInfo = "store/mp/customer-info";

const estimateShipping = "store/mp/carts/mine/estimate-shipping-methods";
const shippingInformation = "store/mp/carts/mine/shipping-information";
const CHECKSUBSCRIPTIONCODE = "check-subscriptioncode/";
// const COOKIE_POLICY = "redington-cookiepolicy/cookiepolicy/search";
const COOKIE_POLICY = "store/mp/redington-cookiepolicy";
const VIDEO_URL = "store/mp/redington-homevideo/homevideo";
const MAINTENANCE_STATUS = "store/mp/maintenance";
const RETRY = "payment/getRetryTime";
const REORDER = "redington/reorder";
// const CHECKEMAILDOMAIN ="checkdomain";
const CHECKEMAILDOMAIN = "store/mp/domain/check-domain";
const PAYMENT_VALIDATION = 'store/payment-status'; 
const CMS_PAGES_BASE = "store/redington/cms-pages?slug=";
const FAQ_URL = `${CMS_PAGES_BASE}faqs`;
const RETURN_POLICY_CMS_URL = `${CMS_PAGES_BASE}enable-cookies`;
const TERMS_AND_CONDITIONS_CMS_URL = `${CMS_PAGES_BASE}reward-points`;
const COOKIE_POLICY_CMS_URL = `${CMS_PAGES_BASE}privacy-policy-cookie-restriction-mode`;

const ABOUT_US_BANNER_STATIC_PATH = `${process.env.PUBLIC_URL || ""}/media/wysiwyg/RedingtonAboutUs.jpg`
// Bundled under public/media/docs (QA Magento path works only on Magento hosts like b2cqaserver).
const TERMS_AND_CONDITIONS_STATIC_PATH = `${process.env.PUBLIC_URL || ""}/media/docs/${
  (process.env.REACT_APP_TERMS_AND_CONDITIONS_URL || "media/docs/Redington-terms-of-engagement-asli-B2C.pdf")
    .split("/")
    .pop()
}`

const apiList = {
  userRegistrationAfterToken: `${LOCAL_HOST}${REGISTER_CUSTOMER}`,
  colorList: `${API_BASE_URL_DEFAULT}${COLOR_LIST_URL}`,
  sizeList: `${API_BASE_URL_DEFAULT}${SIZE_LIST_URL}`,
  productSearch: `${LOCAL_HOST}${CATEGORY_SEARCH}`,
  allProductSearch: `${LOCAL_HOST}${ALL_PRODUCT_SEARCH}`,
  productById: `${LOCAL_HOST}${PRODUCT_BY_ID}`,
  checkOrderReturn: `${LOCAL_HOST}${CHECK_ORDER_RETURN}`,
  confirmReturn: `${API_BASE_URL}${CONFIRM_RETURN}`,
  categoryList: `${API_BASE_URL_DEFAULT}${CATEGORY_LIST}`,
  // session: `${API_BASE_URL}${GUEST_CART}`,
  session: `${LOCAL_HOST}${GUEST_CART}`,
  guestEstimateShipping: GUEST_CART_CHECKOUT_BASE,
  guestShippingInformation: GUEST_CART_CHECKOUT_BASE,
  guestB2cPayment: GUEST_CART_CHECKOUT_BASE,
  guestCcAvenuePayment: GUEST_CART_CHECKOUT_BASE,
  mergeGuestUserCart: `${LOCAL_HOST}${MERGE_CART}`,
  productEnquiry: `${LOCAL_HOST}${PRODUCT_ENQUIRY}`,
  cartItems: "items",
  // shippingInformationBase: `${API_BASE_URL_DEFAULT}${GUEST_CART}`, 
  shippingInformation: `${LOCAL_HOST}${shippingInformation}`,
  order: "/order",
  getCountry: `${LOCAL_HOST}${COUNTRY_LIST}`,
  userRegisteration: `${LOCAL_HOST}${CUSTOMERS}`,
  userLogin: `${LOCAL_HOST}${LOGIN_USER}`,
  userExist: `${LOCAL_HOST}${USER_EXIST}`,
  createUserCartSession: `${LOCAL_HOST}${CARTS_MINE}`,
  userCartItems: `${LOCAL_HOST}${CARTS_MINE}${ITEMS}`,
  getCustomerDetails: `${LOCAL_HOST}${CUSTOMER}`,
  userShippingMethod: `${LOCAL_HOST}${estimateShipping}`,
  updateUserDetails: `${LOCAL_HOST}${UPDATE_ADDRESS}`,
  userShippingBase: `${API_BASE_URL_DEFAULT}`,
  createrOrder: `${LOCAL_HOST}${CARTS_MINE}/b2cpayment-information`,
  // getOrders: `${API_BASE_URL}${PREVIOUSORDERS}`,  
  getOrders: `${LOCAL_HOST}${ORDER_HISTORY}`,
  searchProducts: `${LOCAL_HOST}${PRODUCTSQUERY}`,
  bannerSliders: `${LOCAL_HOST}${BANNERSLIDERS}`,
  recommendedProducts: `${API_BASE_URL}${RECOMMENDEDPRODUCTS}`,
  getEmailDomainForCountryCode: `${LOCAL_HOST}${GETDOMAINDETAILS}`,
  checkSubscriptionCode: `${API_BASE_URL}${CHECKSUBSCRIPTIONCODE}`,
  checkEmailDomain: `${LOCAL_HOST}${CHECKEMAILDOMAIN}`,
  /*Checkout coupons*/
  applyCoupon: `${API_BASE_URL}carts/mine/coupons/apply`,
  removeCoupon: `${API_BASE_URL}carts/mine/coupons`,
  faq : `${LOCAL_HOST}${FAQ_URL}`,
  /*Payment Retry Time*/
  paymentRetry: `${LOCAL_HOST}store/mp/orders/${RETRY}`,

  /*reorder api*/
  reorder: `${LOCAL_HOST}store/mp/orders/${REORDER}`,

  /*OTP Related API */
  // sendOTP: `${API_BASE_URL}${SENDOTP}`,
  sendOTP: `${LOCAL_HOST}${SENDOTP}`,
  verifyOTP: `${LOCAL_HOST}${VERIFYOTP}`,
  resetPassword: `${LOCAL_HOST}${RESET_PASSWORD}`,
  /*Guest User Verify for SAP api*/
  guestuserverify: `${API_BASE_URL}${GUESTUSERVERIFY}`,

  /*Guest User Verify for allowed domain*/
  guestuseralloweddomain: `${LOCAL_HOST}${GUESTUSERALLOWEDDOMAIN}`,

  /*Guest user decrypt url api*/
  guestuserurldecrypt: `${LOCAL_HOST}${GUESTUSERURLDECRYPT}`,
  guestuserVerifyEncryptedUrl: `${LOCAL_HOST}${GUESTUSER_VERIFY_ENCRYPTED_URL}`,

  /*Guest user token api*/
  // guestUserToken: `${API_BASE_URL}${GUESTUSERTOKEN}`,

  /*Password Related */
  // updatePassword: `${API_BASE_URL}${UPDATEPASSWORD}`, 
  updatePassword: `${LOCAL_HOST}${UPDATEPASSWORD}`,

  //Return management
  returnManagement: `${LOCAL_HOST}${RETURN_MANAGEMENT}`,
  //Generate invoice
  generateInvoice: `${API_BASE_URL}${GENERATE_INVOICE}`,
  //To generate Order History response in Ascending order.
  orderHistorySorted:
    "&searchCriteria[sortOrders][0][field]=entity_id&searchCriteria[sortOrders][0][direction]=DESC",
  // paymentSessionUrl:
  //   process.env.REACT_APP_MERCHANT_URL +
  //   process.env.REACT_APP_PAYMENT_SESSION_URL,
  // // paymentValidationUrl: process.env.REACT_APP_BASE_URL + process.env.REACT_APP_PAYMENT_VALIDATION_URL
  // // paymentSessionUrl:
  // //   "https://test-epaygib.mtf.gateway.mastercard.com/api/rest/version/66/merchant/",
  // paymentValidationUrl: `${process.env.REACT_APP_BASE_URL}rest/V1/payment-status`,
  // termsAndConditionsUrl:
  //   process.env.REACT_APP_BASE_URL +
  //   process.env.REACT_APP_TERMS_AND_CONDITIONS_URL,
  // aboutUsAndPrivacyPolicyBackground:
  //   process.env.REACT_APP_BASE_URL +
  //   process.env.REACT_APP_ABOUT_US_AND_PRIVACY_POLICY_BACKGROUND,
  // privacyPolicyContentUrl:
  //   process.env.REACT_APP_BASE_URL +
  //   process.env.REACT_APP_PRIVACY_POLICY_CONTENT_URL,
  // aboutUsContentUrl:
  //   process.env.REACT_APP_BASE_URL + process.env.REACT_APP_ABOUT_US_CONTENT_URL,
  // searchUsContentUrl: `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_SEARCH_US_CONTENT_URL}${SEARCH_PARAMS}`,
  paymentSessionUrl:
    process.env.REACT_APP_MERCHANT_URL +
    process.env.REACT_APP_PAYMENT_SESSION_URL,
  // paymentValidationUrl: appendPath(
  //   API_HOST,
  //   process.env.REACT_APP_PAYMENT_VALIDATION_URL || "rest/V1/payment-status"
  // ), 
  paymentValidationUrl: `${LOCAL_HOST}${PAYMENT_VALIDATION}`,
  // Served from public/media/docs — same PDF as QA Magento media URL.
  termsAndConditionsUrl: TERMS_AND_CONDITIONS_STATIC_PATH,
  // Served from public/media/wysiwyg (bundled with the app — prod Magento host 404s this file).
  aboutUsAndPrivacyPolicyBackground: ABOUT_US_BANNER_STATIC_PATH,
  privacyPolicyContentUrl: appendPath(
    API_HOST,
    process.env.REACT_APP_PRIVACY_POLICY_CONTENT_URL || ""
  ),
  // aboutUsContentUrl: appendPath(
  //   API_HOST,
  //   process.env.REACT_APP_ABOUT_US_CONTENT_URL || ""
  // ),
  aboutUsContentUrl: appendPath(
    LOCAL_HOST,
    process.env.REACT_APP_ABOUT_US_CONTENT_URL || ""
  ),
  // searchUsContentUrl: appendPath(
  //   API_HOST,
  //   `${process.env.REACT_APP_SEARCH_US_CONTENT_URL || "rest/V1/cmsPage/search"}${SEARCH_PARAMS}`
  // ), 
  // searchUsContentUrl: `${LOCAL_HOST}${CMS_PAGE}`,
  cookiePolicyUrl: `${LOCAL_HOST}${COOKIE_POLICY}`,
  videoUrl: `${LOCAL_HOST}${VIDEO_URL}${VIDEOURL_PARAMS}`,
  paymentErrorUrl:
    process.env.REACT_APP_URL_FOR_PAYMENT +
    process.env.REACT_APP_PAYMENT_ERROR_URL,
  paymentCancelUrl:
    process.env.REACT_APP_URL_FOR_PAYMENT +
    process.env.REACT_APP_PAYMENT_CANCEL_URL,
  paymentSuccessUrl:
    process.env.REACT_APP_URL_FOR_PAYMENT +
    process.env.REACT_APP_PAYMENT_SUCCESS_URL,
  paymentMerchantSession:
    process.env.REACT_APP_MERCHANT_URL +
    process.env.REACT_APP_MERCHANT_SESSION_URL,
  paymentTimeoutUrl : "https://b2cqaapp2.redingtonmea.com/sessiontimeout",
  returnPolicyUrl:
    process.env.REACT_APP_BASE_URL + process.env.REACT_APP_RETURN_POLICY_URL,
  logoForPayment:
    process.env.REACT_APP_BASE_URL + process.env.REACT_APP_LOGO_FOR_PAYMENT,
  urlForPayment: process.env.REACT_APP_URL_FOR_PAYMENT,
  shippingTrackingUrl: process.env.REACT_APP_SHIPPING_TRACKING,
  getCategory: LOCAL_HOST + getCategory,
  maxOrderQty: LOCAL_HOST + maxOrderQty,
  userInfo: LOCAL_HOST + userInfo,
  checkStockInfo: LOCAL_HOST + "store/mp/checkout/check-stock-data",
  // ccAvenuePayment: API_BASE_URL + "carts/mine/cc-avenuepayment-information",
  ccAvenuePayment: LOCAL_HOST + "store/mp/carts/mine/cc-avenuepayment-information",

  userCheckoutTermsAndCondition:
    LOCAL_HOST + "store/mp/terms-and-conditions/getlist",
  registerTermsAndCondition:
    LOCAL_HOST + "store/mp/terms-and-conditions/register",
  paymentStatusCCAvenue: API_BASE_URL + "payment-status",
  setEnquiryData: API_BASE_URL + "set-enquiry-data/setEnquiryData",
  // cookiePolicyContentUrl:
  //   process.env.REACT_APP_BASE_URL +
  //   process.env.REACT_APP_COOKIE_POLICY_CONTENT_URL,
  // termsAndConditionPolicyContentUrl:
  //   process.env.REACT_APP_BASE_URL +
  //   process.env.REACT_APP_TERMSANDCONDITION_POLICY_CONTENT_URL,
  // returnPolicyContentUrl:
  //   process.env.REACT_APP_BASE_URL +
  //   process.env.REACT_APP_RETURN_POLICY_CONTENT_URL,

  cookiePolicyContentUrl: `${LOCAL_HOST}${COOKIE_POLICY_CMS_URL}`,
  termsAndConditionPolicyContentUrl: `${LOCAL_HOST}${TERMS_AND_CONDITIONS_CMS_URL}`,
  returnPolicyContentUrl: `${LOCAL_HOST}${RETURN_POLICY_CMS_URL}`,
  searchUsContentUrl: `${LOCAL_HOST}${CMS_PAGES_BASE}`,
  customerServiceUrl: `${LOCAL_HOST}${CMS_PAGE}`,
  // Leading slash when LOCAL_HOST is empty so production (epphub /store proxy) resolves correctly.
  maintenanceStatus: LOCAL_HOST
    ? `${LOCAL_HOST}${MAINTENANCE_STATUS}`
    : `/${MAINTENANCE_STATUS}`,
};

export const queryParams = {
  accessId:
    "&searchCriteria[filter_groups][0][filters][0][field]=access_id&searchCriteria[filter_groups][0][filters][0][value]=",
};

export default apiList;
